<form [formGroup]="form">
  <div
    class="header h-[55px] flex justify-start items-center pl-[24px] mb-[35px] bg-[#DEE2E6]"
  >
    <p class="!m-0">Request for Quotation (RFQ)</p>
    <p
      class="text-[#] !mt-[10px] text-[14px] font-semibold bg-white rounded-full !ml-[15px] px-[13px] !h-[24px] flex items-center justify-center"
    >
      Consultancy Services
    </p>
  </div>

  <div class="!px-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2">
    <span class="label"> Project Management</span>
    <app-rich-textEditor
      (contentChange)="setProjectManagement($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('project_management_control')?.value"
      [placeHolder]="'Project Management'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('project_management_control')?.touched &&
        form.get('project_management_control')?.invalid
      "
      class="error"
    >
      Project management is required
    </div>
    <span> Design Services</span>
    <app-rich-textEditor
      (contentChange)="setDesignService($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('design_service_control')?.value"
      [placeHolder]="'Design Services'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('design_service_control')?.touched &&
        form.get('design_service_control')?.invalid
      "
      class="error"
    >
      Design service is required
    </div>
    <span class="label"> Cost Consultancy/Quantity Surveying </span>
    <app-rich-textEditor
      (contentChange)="setCostConsultancy($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('cost_consultancy_control')?.value"
      [placeHolder]="'Cost Consultancy/Quantity Surveying'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('cost_consultancy_control')?.touched &&
        form.get('cost_consultancy_control')?.invalid
      "
      class="error"
    >
      Cost consultancy/quantity surveying is required
    </div>
    <span class="label">Contract Administration </span>
    <app-rich-textEditor
      (contentChange)="setContractAdministration($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('contract_administration_control')?.value"
      [placeHolder]="'Contract Administration'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('contract_administration_control')?.touched &&
        form.get('contract_administration_control')?.invalid
      "
      class="error"
    >
      Contract administration is required
    </div>
    <span class="label"> Risk Management and Feasibility Studies</span>
    <app-rich-textEditor
      (contentChange)="setRiskManagement($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('risk_management_control')?.value"
      [placeHolder]="'Risk Management and Feasibility Studies'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('risk_management_control')?.touched &&
        form.get('risk_management_control')?.invalid
      "
      class="error"
    >
      Risk management and feasibility studies is required
    </div>
    <span class="label"> Ensure Sustainability and Compliance</span>
    <app-rich-textEditor
      (contentChange)="setSustainabilityCompliance($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('sustainability_compliance_control')?.value"
      [placeHolder]="'Ensure Sustainability and Compliance'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('sustainability_compliance_control')?.touched &&
        form.get('sustainability_compliance_control')?.invalid
      "
      class="error"
    >
      Ensure sustainability and compliance is required
    </div>
    <span class="label"> Final Inspection Sustainability and Compliance</span>
    <app-rich-textEditor
      (contentChange)="setFinalInspection($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('final_inspection_control')?.value"
      [placeHolder]="'Final Inspection Sustainability and Compliance'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('final_inspection_control')?.touched &&
        form.get('final_inspection_control')?.invalid
      "
      class="error"
    >
      Final inspection sustainability and compliance is required
    </div>
  </div>

  <div
    class="!pr-[32px] !mb-[30px] !mt-[40px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        (click)="moveToNextStep()"
      >
        Next
      </button>
    </div>
  </div>
</form>
